<template>
  <el-dialog class='search-dialog' title="条件搜索" :visible.sync="visible" :show-close="true" width="500px" top="10vh">
      <div style="display: flex;flex-flow: row nowrap; justify-content: space-between;margin-bottom: 10px;">
        <el-radio-group v-model="condition" size='mini'>
          <el-radio-button label="AND">与</el-radio-button>
          <el-radio-button label="OR">或</el-radio-button>
          <el-radio-button label="NOT">非</el-radio-button>
        </el-radio-group>
      </div>
      <div v-for="(item,index) in models" :key="index" style="display: flex;flex-flow: row nowrap; justify-content: start;align-items: center;margin: 5px 0;">
        <el-select
          v-model="item.field"
          placeholder="请选择字段"
          size="small"
          style="width:120px;margin-right: 5px;"
          >
          <el-option
            v-for="item in fieldOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-select
          v-model="item.keywords"
          v-if="['Name'].includes(item.field)"
          style="width:390px;margin-left:4px"
          size="small"
          placeholder="请选择物料名称"
          >
          <el-option v-for="item in filterName" :key="item.text" :label="item.text" :value="item.value"></el-option>
        </el-select>
        <el-select
          v-model="item.keywords"
          v-if="['Brand'].includes(item.field)"
          style="width:390px;margin-left:4px"
          size="small"
          placeholder="请选择品牌名称"
          >
          <el-option v-for="item in filterBrand" :key="item.text" :label="item.text" :value="item.value"></el-option>
        </el-select>
        <el-select
          v-model="item.keywords"
          v-if="['Supplier'].includes(item.field)"
          style="width:390px;margin-left:4px"
          size="small"
          filterable
          remote
          clearable
          :remote-method="remoteSupplier"
          placeholder="请选择供应商"
          >
          <el-option v-for="item in supplierList" :key="item._id" :label="item.name" :value="item._id"></el-option>
        </el-select>
        <el-select
          v-model="item.keywords"
          v-if="['PIC'].includes(item.field)"
          style="width:390px;margin-left:4px"
          size="small"
          placeholder="请选择负责人"
          >
          <el-option
            v-for="item in customerACL"
            :key="item._id"
            :label="item.nickname"
            :value="item._id">
          </el-option>
        </el-select>
        <el-input size="small" style="width:390px;;margin-left:4px" v-if="['Description'].includes(item.field)" v-model="item.keywords" placeholder="请输入搜索关键字"></el-input>
        <el-date-picker
          unlink-panels
          size="small"
          v-model="item.keywords"
          style="width:390px;margin-left: 3px;"
          v-if="item.field=='Date'"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <i class="el-icon-circle-plus" v-if="index==0" @click="addItem"></i>
        <i class="el-icon-remove" v-if="index!=0" @click="deleteItem(index)"></i>
      </div>
      <div style="text-align: center;margin-top: 20px;">
        <el-button type="primary" size='small' icon="el-icon-search" @click="submit">搜索</el-button>
      </div>
  </el-dialog>
</template>
<script>
import http from '@/http'
export default {
  data() {
    return {
      visible: false,
      condition:'AND',
      filterName:[],
      filterBrand:[],
      supplierList:[],
      customerACL:[],
      demandId:'',
      models: [{field:'Name'}]
    };
  },
  computed:{
    fieldOptions(){
      return [
        {
          value: 'Name',
          label: '名称'
        },{
          value: 'Brand',
          label: '品牌'
        },{
          value: 'Description',
          label: '描述'
        },{
          value: 'Supplier',
          label: '供应商'
        },{
          value: 'Date',
          label: '询价日期'
        },        
        {
          value: 'PIC',
          label: '负责人'
        }]
    }
  },
  methods:{
    async fetchFilter(){
      const res=await http.get(`/crm/demandDetail/demandId/${this.demandId}`);
      this.filterBrand=[]
      this.filterName=[]
      res.data.forEach(item=>{
        let Brand = this.filterBrand.find(i => i.text === item.Brand);
        if (!Brand) {
          this.filterBrand.push({text:item.Brand,value:item.Brand})
        }
        let Name = this.filterName.find(i => i.text === item.Name);
        if (!Name) {
          this.filterName.push({text:item.Name,value:item.Name})
        }
      })
    },
    async remoteSupplier(query){
      if(query!==''){
        const res=await http.get('/srm/supplier/keywords',{params:{keywords:query}});
        this.supplierList=res.data
      }
    },
    //提交验证表单数据
    async submit() {
        const data= this.models.map(model=>{
          let obj={}
          switch(model.field){
            case 'Name':
            Object.defineProperty(obj,model.field,{
              enumerable: true,
              configurable: true,
              writable: true,
              value: {$regex: model.keywords}
            });
            break;
            case 'Brand':
            Object.defineProperty(obj,model.field,{
              enumerable: true,
              configurable: true,
              writable: true,
              value: {$regex: model.keywords}
            });
            break;
            case 'Description':
            Object.defineProperty(obj,model.field,{
              enumerable: true,
              configurable: true,
              writable: true,
              value: {$regex: model.keywords,$options:'i'}
            });
            break;
            case 'PIC':
            Object.defineProperty(obj,model.field,{
              enumerable: true,
              configurable: true,
              writable: true,
              value: {$eq: model.keywords}
            });
            break;
            case 'Supplier':
            Object.defineProperty(obj,'Inquiry',{
              enumerable: true,
              configurable: true,
              writable: true,
              value: {$elemMatch:{Supplier:{$eq: model.keywords}}}
            });
            break;
            case 'Date':
            Object.defineProperty(obj,'Inquiry',{
              enumerable: true,
              configurable: true,
              writable: true,
              value:{$elemMatch:{Date: {$gte: model.keywords[0],$lte: new Date(model.keywords[1].getTime() + 24 * 60 * 60 * 1000 - 1)}}}
            });
            break;
            default:
              console.log('请选择对比条件');
          }
          return obj
        })
        let keywords=null
        if(this.condition=='AND'){
          data.push({demandId:this.demandId})
          keywords=JSON.stringify({$and:data})
        }else if(this.condition=='OR'){
          keywords=JSON.stringify({$and:[{demandId:this.demandId},{$or:data}]})
        }else{
          keywords=JSON.stringify({$and:[{demandId:this.demandId},{$nor:data}]})
        }
        const res = await http.get(`/crm/demandDetail/search`,{
          params: { keywords}
        })
        this.callback(res.data)
        this.visible=false
    },
    addItem(){
      this.models.push({
        field:'',
        keywords:'',
      })
    },
    deleteItem(index){
      this.models.splice(index,1)
    }
  },
  created(){
    this.fetchFilter()
  }
};
</script>
<style scoped>
.el-icon-remove{
  cursor: pointer;
  font-size: 18px;
  color:#F56C6C;
  margin: 0 3px;
}
.el-icon-circle-plus{
  cursor: pointer;
  font-size: 18px;
  color: #409eff;
  margin: 0 3px;
}
.search-dialog>>>.el-dialog__body{
  padding: 10px 20px 20px 20px;
}
</style>
